// © 2026 AttainIP Engineering
import { DetailGrid, type DetailRow } from './DetailGrid';

function formatCurrency(amountCents: number | null | undefined, currency: string | null | undefined): string | null {
  if (amountCents == null || !currency) return null;
  const amount = amountCents / 100;
  return new Intl.NumberFormat('en', { style: 'currency', currency: currency.toUpperCase() }).format(amount);
}

export function PaymentDetail({ tx }: { tx: any }) {
  const rows: DetailRow[] = [
    ['transaction_id', tx.id],
    ['user_id', tx.user_id],
    ['user_email', tx.user_email],
    ['user_name', tx.user_name],
    ['transaction_type', tx.transaction_type],
    ['amount (credits)', tx.amount],
    ['balance_after', tx.balance_after],
    ['amount_cents', tx.amount_cents],
    ['currency', tx.currency],
    ['formatted_amount', formatCurrency(tx.amount_cents, tx.currency)],
    ['package_id', tx.package_id],
    ['description', tx.description],
    ['analysis_id', tx.analysis_id],
    ['stripe_event_id', tx.stripe_event_id],
    ['stripe_session_id', tx.stripe_session_id],
    ['stripe_payment_intent_id', tx.stripe_payment_intent_id],
    ['created_at', tx.created_at ? new Date(tx.created_at).toLocaleString() : null],
  ];
  return <DetailGrid rows={rows} />;
}
